import { Button, Modal } from 'antd'
import React from 'react'
import { useNavigate } from 'react-router';
import ClockImage from '@/assets/images/clock.png';
import DiamondImage from '@/assets/images/diamond.png';
import { LockOutlined, TrophyOutlined } from '@ant-design/icons';
import { useSettings } from "@/store/settingStore";
import { ThemeMode } from "#/enum";

const PaymentDueModal = ({open , onClose, notificationData}) => {
  const navigate = useNavigate();
  const { themeMode } = useSettings();
  const isDark = themeMode === ThemeMode.Dark;

  if (!notificationData) return null;

  return (
    <Modal open={open} onCancel={onClose} footer={null} centered maskClosable>
        <div className={`w-full flex flex-col gap-y-4 ${isDark ? 'text-white' : 'text-gray-900'}`}>
            <div className='mx-auto w-[80px] h-[80px] rounded-full flex items-center justify-center mt-2'>
                <img src={ClockImage} alt='clock-image' className='w-full h-full object-contain'/>
            </div>
            <div className='w-full flex-col text-center h-max'>
                <p className='text-2xl font-bold tracking-tight'>{notificationData.title}</p>
                <span className={`text-lg font-medium mt-1 block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                  Due Date: {notificationData.due_date}
                </span>
            </div>
            <div className='w-10/12 text-center mx-auto'>
              <span className={`text-[15px] font-medium leading-relaxed ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                {notificationData.message}
              </span>
            </div>

            <div className={`w-full p-4 h-[75px] rounded-xl border mt-2 flex items-center justify-between ${isDark ? 'bg-[#C41230]/10 border-[#C41230]/20' : 'bg-[#C41230]/5 border-[#C41230]/10'}`}>
                  <div className='flex items-center h-full gap-3.5'>
                        <TrophyOutlined style={{fontSize:"22px",color:"#C41230"}}/>
                        <div className='flex flex-col text-left'>
                          <span className={`text-[13px] font-bold ${isDark ? 'text-gray-200' : 'text-gray-900'}`}>Don't lose access to premium features</span>
                          <span className={`text-[12px] font-medium ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>Complete your payment and keep everything you love.</span>
                        </div>
                  </div>
                  <img src={DiamondImage} alt="Diamond" className='w-[36px] h-[36px] object-contain opacity-90'/>
            </div>

            <div className='w-full flex items-center gap-4'>
                <Button 
                    type='primary' 
                    className='w-1/2' 
                    style={{height:60}} 
                    onClick={() => { onClose(); navigate('/dashboard/upgrade-plan'); }}
                >
                    Pay Now
                </Button>
                <Button className='w-1/2' style={{height:60}} onClick={onClose}>Maybe Later</Button>
            </div>

            <div className='w-full flex items-center justify-center gap-2'>
              <LockOutlined className='text-black/40'/>
              <span className='text-[12px] font-bold text-black/40'>Secure & hassle-free payment</span>
            </div>
        </div>
    </Modal>
  )
}

export default PaymentDueModal
